import { useAuth } from '../../contexts/AuthContext'
import { Link } from "react-router-dom";

const Footer = () => {
  const { currentUser } = useAuth()

  return (
    <footer className="relative bottom-0 w-full h-[10vh] flex global-px items-center text-base text-white bg-darkOrange pt-5 pb-4 justify-self-end text-center sm:h-[7vh] sm:text-lg">
      <div className="absolute w-full h-[4.5px] shadow-md shadow-ivory -top-1 left-0" />
      <span className=" w-1/2 flex justify-start">
        <span className="cursor-pointer">Termes et conditions</span>
      </span>
      <span className="w-1/2 flex justify-end">
        {currentUser ? <Link to="dataProtectionLoggedIn">Politique de confidentialité</Link> : <Link to="dataProtectionDisconnected">Politique de confidentialité</Link>}
      </span>
    </footer>
  );
};

export default Footer;
